
@use '../../base-variables.scss';

.EditorCanvas {
    left: base-variables.$entity-menu-width;
    width: calc(100% - 272px - base-variables.$entity-menu-width) !important;
    height: 100%;
}